import classNames from 'classnames';
import * as React from 'react';
import { Link, LinkProps, NavLink, NavLinkProps } from 'react-router-dom';
import { branch } from 'recompose';
import withIcon from '../../hocs/withIcon';
import { ISvgIconGeneralProps } from '../SvgIcon';
import './styles.scss';
import styled from 'styled-components';

export interface IMPLinkProps extends LinkProps, NavLinkProps, ISvgIconGeneralProps {
  iconName?: string;
  isNavLink?: boolean;
  isExternal?: boolean;
  activeClassName?: string;
}

const MPLink: React.FunctionComponent<IMPLinkProps> = ({
  className,
  isNavLink,
  isExternal,
  activeClassName,
  ...props
}) => {
  const cn = classNames('MPLink', className);

  if (isNavLink) {
    return <NavLink {...props} className={cn} activeClassName={activeClassName} />;
  }

  if (isExternal) {
    return (
      <a className={cn} href={props.to as string}>
        {props.children}
      </a>
    );
  }

  return <Link {...props} className={cn} />;
};

MPLink.defaultProps = {
  isNavLink: false,
  activeClassName: 'isActive',
};

export default branch<IMPLinkProps>(({ iconName }) => Boolean(iconName), withIcon('MPLink'), React.memo)(MPLink);

export const BoldLink = styled(MPLink)`
  font-weight: ${p => p.theme.font.weight.medium};
`;

export const BlueLink = styled(BoldLink)`
  color: ${p => p.theme.colorCerulean} !important;
`;



// WEBPACK FOOTER //
// ./src/components/MPLink/index.tsx